<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <div class="h-full flex flex-col ">
    <div class="mb-3">
      <button [disabled]="parent.isReadOnly()" (click)="onPvAdd()" pButton type="button" label="Add Compliance" icon="pi pi-plus"
        class="p-button-sm"></button>
    </div>
    <div class="grow">
      <prox-ag-grid [gridOptions]="pvGridOptions" [rowData]="programViews"></prox-ag-grid>
    </div>
  </div>
</div>
